import { callApiToServer } from "../callApi";

export async function createAppContent(authtoken, appContentObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(appContentObject);

    let endUrl = "v1/auth/admin/add-static-page";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
